import { useEffect, useMemo, useReducer, useState } from 'react';
import { crdtClient, HandshakeQuery } from '@larki/mp';

export type RealtimeClientConnectionState =
  | {
      status: 'connecting';
    }
  | {
      status: 'connected';
    }
  | {
      status: 'error';
      error: Error;
    }
  | {
      status: 'disconnected';
    };

const realtimeClientReducer = (
  state: RealtimeClientConnectionState,
  action:
    | { type: 'connect_error'; payload: Error }
    | { type: 'connect' }
    | { type: 'disconnect' }
): RealtimeClientConnectionState => {
  switch (action.type) {
    case 'connect_error':
      return { status: 'error', error: action.payload };
    case 'connect':
      return { status: 'connected' };
    case 'disconnect':
      return { status: 'disconnected' };
    default:
      return state;
  }
};

export const useClient = (query: HandshakeQuery) => {
  const [connectionState, dispatch] = useReducer(realtimeClientReducer, {
    status: 'connecting',
  });

  const [client] = useState(() => {
    return new crdtClient.Client({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      url: process.env.MP_SERVER_URL!,
      query,
      autoOn: false,
      eventListeners: {
        connect: () => dispatch({ type: 'connect' }),
        connectError: (err) =>
          dispatch({ type: 'connect_error', payload: err }),
        disconnect: () => dispatch({ type: 'disconnect' }),
      },
    });
  });

  useEffect(() => {
    client.on();
    return () => {
      client.io.disconnect();
      client.off();
    };
  }, [client]);

  return useMemo(() => ({ client, connectionState }), [client, connectionState]);
};


